export default __webpack_public_path__ + "assets/images/fb4dd8a0567b08bad2b33d4cda1f6e95.png";